<div class="c-cms-form" sk-field="{{field.fieldName}}">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row">
                <textarea class="form-control" skf-change="$parent.textChange('{{field.fieldName}}')" skf-text="$field.value? $field.value : ''"></textarea>
            </div>
            <div class="form-error" skf-if="$field.dirty && $field.invalid" skf-text="$field.validationMessage"></div>
            <div class="form-row form-flex send-code" skf-if="$field.isSendSms == 1">
                <input type="text" class="form-control" skf-change="$parent.setCode('{{field.fieldName}}')" skf-value="$field.verificationCode" />
                <input type="button"  class="send-button"
                       skf-value="$field.sendCodeJson.time == 0 ? '获取验证码' : $field.sendCodeJson.time + '秒'"
                       skf-disabled="$field.sendCodeJson.disabled"
                       skf-click="$parent.sendCode('{{field.fieldName}}', 'customForm')"/>
            </div>
            <div class="form-error" skf-if="$field.isSendSms == 1 && $field.verificationCodeDirty && $field.verificationCodeError">请输入验证码</div>
        </div>
    </div>
</div>